export const POS_SENTRY_DSN = process.env['NX_POS_SENTRY_DSN'];
export const KIOSK_SENTRY_DSN = process.env['NX_KIOSK_SENTRY_DSN'];
export const WAITING_SENTRY_DSN = process.env['NX_WAITING_SENTRY_DSN'];
